// ============================================
// CHECKOUT BUTTON PRICE CORRECTOR (v2 — exact selector)
//
// Targets the exact element confirmed from your button's HTML:
//   <button id="buyNow1CheckoutBtn" class="btn-1checkout ...">
//     <span class="btn-1checkout-title">
//       Checkout <span class="btn-1checkout-price">₹0.00</span>
//     </span>
//   </button>
//
// Does NOT touch the 1Checkout script. Does NOT depend on which of
// the many cart.js / section-render calls feeds the button — it just
// watches .btn-1checkout-price directly and corrects it if it's wrong.
// ============================================
(function() {
  const MAX_RETRIES = 5;
  const RETRY_DELAY = 350; // ms
  const PRICE_SELECTOR = '.btn-1checkout-price';

  function formatPrice(cents) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function isZero(text) {
    // Matches ₹0.00, ₹0, Rs.0.00, 0.00, etc.
    return /(?:₹|Rs\.?)?\s*0(?:\.00)?\s*$/.test((text || '').trim());
  }

  function fetchCartWithRetry(attempt) {
    attempt = attempt || 0;
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        const inconsistent = cart.item_count > 0 && cart.total_price === 0;
        if (inconsistent && attempt < MAX_RETRIES) {
          return new Promise(function(resolve) {
            setTimeout(function() {
              resolve(fetchCartWithRetry(attempt + 1));
            }, RETRY_DELAY);
          });
        }
        return cart;
      });
  }

  let checking = false;

  function checkAndFix() {
    const priceEls = Array.from(document.querySelectorAll(PRICE_SELECTOR))
      .filter(function(el) { return isZero(el.textContent); });

    if (priceEls.length === 0 || checking) return;

    checking = true;
    fetchCartWithRetry()
      .then(function(cart) {
        if (cart.item_count === 0) return; // genuinely empty — 0 is correct
        const correctPrice = formatPrice(cart.total_price);
        priceEls.forEach(function(el) {
          if (isZero(el.textContent)) {
            el.textContent = correctPrice;
          }
        });
      })
      .catch(function(err) { console.error('Checkout price corrector error:', err); })
      .finally(function() { checking = false; });
  }

  // Watch for DOM changes (drawer opening, price span re-rendering, etc.)
  let debounceTimer = null;
  const observer = new MutationObserver(function() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkAndFix, 150);
  });

  function start() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    checkAndFix();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Also re-check on common cart events, in case they exist/fire.
  document.addEventListener('cart:change', checkAndFix);
  document.addEventListener('cart-drawer:refreshed', checkAndFix);
})();